module.exports = __webpack_public_path__ + "img/kachel-HERZKREISLAUF-VITAAKTIV.67cd3e16.png";